<h1 mat-dialog-title>
    {{title}}
  </h1>
  
  <div mat-dialog-content>
    <div [innerHTML]="message" style="white-space: pre-wrap; font-size: 0.95rem; line-height: 1.5; color: #2d3748;"></div>
  </div>
  
  <div mat-dialog-actions class="mdc-action-container">
    <button *ngIf="showNoButton" mat-button (click)="onDismiss()">{{noButtonCaption}}</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">{{yesButtonCaption}}</button>
  </div>